<template>
  <div class="app">
    <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
      <a class="navbar-brand" href="#">Categorías</a>
    </nav>

    <div class="container my-4" style="padding-bottom:500px;padding-top:50px">
      Nombre categoría:
      <input
        class="form-control mr-sm-2 mb-3"
        type="text"
        style="width:200px"
        v-model="category"
      />

      <div v-for="(word, idx) in categoryWords" :key="idx">
        <span>{{ word }} </span>
        <button @click="removeWord(idx)" class="btn btn-primary btn-sm">
          X
        </button>
      </div>

      <multiselect
        v-model="newWord"
        :options="multiselectOptions"
        @input="addWord()"
        class="my-3"
        :close-on-select="false"
      ></multiselect>

      <hr />

      <p>{{ categoryData }}</p>
    </div>
  </div>
</template>

<script>
const words = require("../data/es/words.json");
const normWords = removeChars(words);

const categories = require("../data/es/categories.json");

import Multiselect from "vue-multiselect";

function removeChars(wordList) {
  const ret = [];
  for (let i = 0; i < wordList.length; i++) {
    ret.push(wordList[i].normalize("NFKD").replace(/[\u0300-\u036F]/g, ""));
  }
  return ret;
}

export default {
  components: { Multiselect },
  data() {
    return {
      words: words,
      category: "",
      categoryWords: [],
      newWord: "",
      multiselectOptions: normWords,
    };
  },
  computed: {
    categoryData() {
      return {
        category: this.category,
        words: this.categoryWords,
      };
    },
  },
  methods: {
    removeWord(idx) {
      this.categoryWords.splice(idx, 1);
    },
    addWord() {
      this.categoryWords.push(this.newWord);
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.text-not {
  color: rgb(170, 170, 170);
}
</style>
